/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StudentRouteLinkItem from './StudentRouteLinkItem';
import ScheduleIcon from 'icons/ScheduleIcon';

const messages = defineMessages({
  title: {id: 'navigation.schedule'},
});

const ScheduleItem = () => (
  <StudentRouteLinkItem
    iconBefore={ScheduleIcon}
    route="midas/student/schedule"
    title={messages.title}
  />
);

export default ScheduleItem;
